import { jsx as _jsx } from "react/jsx-runtime";
import { PresentationPlanProvider } from "../../context/PresentationPlanProvider";
import PresentationPlanView from "./PresentationPlanView";
/**
 * Wrapper component that provides context to PresentationPlanView
 * This eliminates prop drilling by providing state through React Context
 */
const PresentationPlanViewWithContext = (props) => {
    return (_jsx(PresentationPlanProvider, { children: _jsx(PresentationPlanView, { ...props }) }));
};
export default PresentationPlanViewWithContext;
